module.exports = __webpack_public_path__ + "img/drivedatawall.57be443b.png";